export const SUCCESS = "S00000";
export const SERVER_ERROR_CODE = "F00000";
export const SERVER_ERROR_CODE_MSG = "서버통신에 실패했습니다.";
export const TOKEN_ERROR_CODE = "F00001";
export const REQ_TYPE_PRIVATE = "01";
export const REQ_TYPE_PRIVATE_NM = "개인";
export const REQ_TYPE_COMMON = "02";
export const REQ_TYPE_COMMON_NM = "공용";

export const REQUEST_BOOK_SUCCESS_MSG = "도서신청이 완료되었습니다.";
export const REQUEST_BOOK_TITLE_ERROR_MSG = "검색할 도서명을 입력하세요.";
export const DEFAULT_ACTIVE_PAGE = 0;
export const DEFAULT_COUNT = 5;

export const YES24_PRODUCT_DETAIL_URL = "http://www.yes24.com/Product/Goods/";
// 이미지는 HTTPS 페이지 Mixed Content 차단 회피 위해 https. yes24 image 도메인 https 지원.
export const YES24_GOODS_IMG_URL = "https://image.yes24.com/Goods/";

// eslint-disable-next-line no-useless-escape
export const SPECIAL_CHAR_REG_EX = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
export const SPECIAL_CHAR_BOOK_NAME_REG_EX = /(<([^>]+)>)/gi;
// eslint-disable-next-line no-useless-escape
export const CHAR_REG_EX = /\`/gi;
// eslint-disable-next-line no-useless-escape
export const REG_EX_PASSWORD = /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&~\*+=/-]).*$/;
export const REG_EX_EMP_NUM = /^[0-9]{0,6}$/;

export const JOIN_SUCCESS_MSG = "회원가입에 성공하셨습니다.";
export const UPDATE_MEMBER_INFO_SUCCESS_MSG = "비밀번호가 변경되었습니다.";

export const KYOBO_PRODUCT_URL =
  "https://search.kyobobook.co.kr/api/webAutomaticKeyword?&ejkGb=EBK&";

export const KYOBO_PRODUCT_DETAIL_URL =
  "http://digital.kyobobook.co.kr/digital/ebook/ebookDetail.ink?barcode=";

// 이미지는 HTTPS 페이지 Mixed Content 차단 회피 위해 https. 교보 image 도메인 https 지원.
export const KYOBO_GOODS_IMG_URL =
  "https://image.kyobobook.co.kr/images/book/large/";

export const RIDI_PRODUCT_URL = "/book/getRidiBookInfo";
// export const RIDI_PRODUCT_URL = "https://ridibooks.com/search/?q=";

export const RIDI_PRODUCT_DETAIL_URL = "https://ridibooks.com";

export const RIDI_GOODS_IMG_URL = "https://img.ridicdn.net/cover/";
